import React, { useEffect } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { BillDataTable } from "./DataTable";
import { useBillModel } from "./billModel";
import { WriteoffDrawer } from "./WriteoffDrawer";

export const BillDataBox = () => {
    const {
        state,
        dataSource,
        billSummaryData,
        selectedRowKeys,
        selectedData,
        setWriteoffDrawerVisible,
        loadData,
        setSelectedData,
    } = useBillModel();

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [state])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "已核销总额",
            value: billSummaryData?.totalWriteoffAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
        {
            label: "未核销总额",
            value: billSummaryData?.totalUnWriteoffAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.red
        },

    ]

    const onWriteoff = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.status === 1) {
                setWriteoffDrawerVisible(true);
            } else {
                message.warning("账单状态不可核销！")
            }
        } else {
            message.error("请选择核销账户!");
        }
    }

    const action = (
        <>
            <div>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onWriteoff}
                >
                    核销
                </Button>
                {/* <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onAdjust}
                >
                    导出
                </Button> */}
            </div>

        </>
    );

    return (
        <>
            <YhBox title={"账单列表"} descriptions={desc} action={action}>
                <BillDataTable />
            </YhBox>
            <WriteoffDrawer />
        </>
    )
}
